import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=d6aafc22&scoped=true&"
import script from "./sign-up.vue?vue&type=script&lang=js&"
export * from "./sign-up.vue?vue&type=script&lang=js&"
import style0 from "./sign-up.vue?vue&type=style&index=0&id=d6aafc22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aafc22",
  null
  
)

export default component.exports